/**
 * Read a dollar-override input: blank, non-numeric, zero or negative mean "no override" (null),
 * which the server turns back into the default.
 */
export function parse_dollar_override(raw: string): number | null {
  const parsed = parseFloat(raw)
  return raw.trim() === "" || !Number.isFinite(parsed) || parsed <= 0 ? null : parsed
}
